import ApiClient from './ApiClient'

const client = new ApiClient()

export default {
  /**
   * トークショーtsv取得
   */
  getTalkShows () {
    return client.get('talk_shows')
  },
  /**
   * 特別展示tsv取得
   */
  getSpecialExhibitions () {
    return client.get('special_exhibitions')
  },
  /**
   * 特別展示作品tsv取得
   */
  getSpecialExhibition (id) {
    return client.get(`special_exhibitions/${id}`)
  }
}
